import { selectionText } from './columnFilters'
import type { DailyRosterFilters, DailyRosterRow } from './dailyRosterFigures'
import type { ExportTable } from './reportExport'

export const DAILY_ROSTER_COLUMNS = [
  { header: 'Unit', width: 18 },
  { header: 'Shift', width: 18 },
  { header: 'Title', width: 30 },
  { header: 'Name', width: 24 },
  { header: 'Assignment', width: 26 },
]

export function dailyRosterTable(
  rows: DailyRosterRow[],
  input: { date: string; filters: DailyRosterFilters; teams: Map<string, string>; generatedAt: Date },
): ExportTable {
  const { filters } = input
  return {
    title: 'Daily Roster',
    parameters: [
      { label: 'Date', value: input.date },
      { label: 'Unit', value: selectionText(filters.unit, (id) => input.teams.get(id) ?? 'Unknown unit') },
      { label: 'Shift', value: selectionText(filters.shift) },
      { label: 'Title', value: selectionText(filters.title) },
      { label: 'Assignment', value: selectionText(filters.assignment) },
      ...(filters.employee ? [{ label: 'Name', value: filters.employee.length === 1 ? '1 selected' : `${filters.employee.length} selected` }] : []),
    ],
    generatedAt: input.generatedAt,
    columns: DAILY_ROSTER_COLUMNS,
    rows: rows.map((row) => [row.unit, row.shift, row.title, row.employee, row.assignment]),
  }
}
